
import React from 'react';
import Main from './main';

const App = () => (
  <div className="ui container">
    <Main />   
  </div>
);
export default App;
// npm install --save serialize-javascript

// SET SASS_PATH=.\node_modules
// export SASS_PATH=./node_modules
// "postbuild": "node scripts/build_extras/build.js"

// "homepage": "/esign"

/*

import React from "react";
import { Link, Route, Switch } from "react-router-dom";

const Home = () => (
  <div>
    <h2>Home</h2>
  </div>
);

const Category = () => (
  <div>
    <h2>Category</h2>
  </div>
);

const Products = () => (
  <div>
    <h2>Products</h2>
  </div>
);

export default function App() {
  return (
    <div>
      <nav className="navbar navbar-light">
        <ul className="nav navbar-nav">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/category">Category</Link>
          </li>
          <li>
            <Link to="/products">Products</Link>
          </li>
        </ul>
      </nav>

      
      <Route path="/"><Home /></Route>
      <Route path="/category"><Category /></Route>
      <Route path="/products"><Products /></Route>
    </div>
  );
}
*/